import script from "./EmailComposer.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailComposer.vue?vue&type=script&setup=true&lang=ts"

import "./EmailComposer.vue?vue&type=style&index=0&id=11aafc64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11aafc64"]])

export default __exports__